// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    AttributeTypeModel,
    BaseModel,
    CarrierDto,
    CartLineModel,
    DocumentModel,
    PaginationModel,
    ProductModel,
} from "@insite/client-framework/Types/ApiModels";

export interface GreifOrderHistoryExportSettings {
    enforceMaxNumberOfImports: boolean;
    maxNumberOfImports: number;
    enforceMaxDateRangeOfImports: boolean;
    maxDateRangeOfImports: number;
}

export interface GreifInvoiceHistoryExportSettings {
    enforceMaxNumberOfImports: boolean;
    maxNumberOfImports: number;
    enforceMaxDateRangeOfImports: boolean;
    maxDateRangeOfImports: number;
}

export interface FeatureFlagsSettings {
    enableAccessoryUpsell: boolean;
    enableCartRedesign: boolean;
    enableCheckoutTaxAlert: boolean;
    enableMyAccountRedirect: boolean;
    enablePackagingAdvice: boolean;
    enableSimpleRequestQuote: boolean;
    preventHomePageRedirectionOnShipToChange: boolean;
}

export interface PricingSettings {
    showSavingsMessage: boolean;
}

export interface MaintenanceBannerSettings {
    enableMaintenanceBanner: boolean;
}

export interface OrderComplaintModel extends BaseModel {
    erpNumber: string;
    type: string;
    complaintDescription: string;
    suggestedSolutionDescription?: string;
    documents: [];
    phoneNumber: string | number;
    orderHistoryLineId: string | null;
    message: string;
    isSafetyIssue: boolean;
    isFoodSafetyIssue: boolean;
    isSample: boolean;
    customerComplaintNumber: string | number;
    complaintQuantity: number | null;
}

export interface TaxExemptionCertificateCollectionModel extends BaseModel {
    taxExemptionCertificates: TaxExemptionCertificateModel[] | null;
    pagination: PaginationModel | null;
}

export interface TaxExemptionCertificateModel extends BaseModel {
    id: string;
    soldToBpCode: string;
    state: string;
    financeCompanyCode: string;
    financeCompanyName: string;
    soldToBpName: string;
    status: string;
    expiryDate: string;
    properties: {};
}

export interface TECNotificationModel extends BaseModel {
    taxExemptionCertificateId: string | null;
    financeCompany: string;
    message: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    state: string;
    documents: {
        data: string;
        fileName: string;
    }[];
    isNewCertificate: boolean | null;
}

export interface TECMessagesCollectionModel extends BaseModel {
    tecMessages: TECMessagesModel[];
}

export interface TECMessagesModel extends BaseModel {
    id: string;
    status: string;
    message: string;
}

export interface TECFinanceCompanyModel extends BaseModel {
    id: string;
    financeCompanyCode: string;
    financeCompanyName: string;
}

export interface PowerBIReportModel extends BaseModel {
    embedReportId: string;
    embedUrl: string;
    embedReportName: string;
    accessToken: string;
    allowedCustomers: { [key: string]: string[] };
}

export interface SplitOrderModel extends BaseModel {
    key: string;
    plant: string;
    status: string;
    statusDisplay: string;
    orderCarrier: string;
    deliveryTerms: string;
    paymentTerms: string;
    currency: string;
    totalTax: number;
    totalTaxDisplay: string;
    orderSubTotal: number;
    orderSubTotalDisplay: string;
    orderGrandTotal: number;
    orderGrandTotalDisplay: string;
    notes: string;
    errorMessages: string[];
    warningMessages: string[];
    lines: CartLineModel[];
}

export interface SplitOrderCartLineNotesModel extends BaseModel {
    cartId: string;
    cartLineId: string;
    id: string;
    notes: string;
}

export interface SplitOrderCartNotesModel extends BaseModel {
    cartId: string;
    deliveryDateIds: string[];
    notes: string;
}

export interface SalesRepModel extends BaseModel {
    salespersonNumber: string;
    name: string;
    salesClass: string;
    code: string;
    referenceNumber: string;
    isOutsideRep: boolean;
    salesPeriodToDate: number;
    salesYearToDate: number;
    email: string;
    phone1: string;
    phone2: string;
    title: string;
    userProfileId: string;
    imagePath: string;
    description: string;
    minMarginAllowed: number;
    maxDiscountPercent: number;
    salesManagerId: string | null;
    id: string;
}

export interface SessionSalespersonPropertyModel {
    salesperson: SalesRepModel;
    telOffice: string;
}

export interface CsrRepModel {
    address: string;
    cellPhone: string;
    email: string;
    firstName: string;
    lastName: string;
    officePhone: string;
    role: string;
    isDefaultPlant: boolean;
    plant: string;
    plantDisplayName: string;
}

export interface OrderChangeRequestModel {
    orderId: string;
    erpNumber: string;
    newPoNumber?: string;
    newRequestedDate?: Date;
    newLines?: OrderChangeRequestNewLineModel[];
    orderLines: OrderChangeRequestLineModel[];
    newShipToCompanyName?: string;
    newShipToAddress1?: string;
    newShipToCity?: string;
    newShipToState?: string;
    newShipToPostalCode?: string;
    newShipToCountry?: string;
    newShipToCode?: string;
    probability?: number;
}

export interface OrderChangeRequestLineStateModel {
    changeReason: string;
    changeNotes: string;
    hasError?: boolean;
    isCanceled?: boolean;
    originalQuantity?: number | string;
    newQuantity: number | string;
}

export interface OrderChangeRequestLineModel extends OrderChangeRequestLineStateModel {
    orderLineId: string;
    leadTimeInWeeks: string;
    plant: string;
}

export interface OrderChangeRequestNewLineModel extends OrderChangeRequestLineStateModel {
    product: ProductModel;
    productInfo: ProductInfo;
}

export interface OrderChangeRequestChangeModel {
    probability: number;
    typeOfChange?: string;
    lineId?: string;
}

export interface GreifOrderUploadFileModel {
    data: string;
    fileName: string;
}

export interface GreifOrderUploadModel {
    documents: GreifOrderUploadFileModel[];
    document: GreifOrderUploadFileModel;
    errors: string;
    message: string;
    webOrderNumber: string;
}

export interface GreifCreateCartUploadModel {
    webOrderNumber: string;
}

export interface ContactUsPropertiesApiParameter {
    userCompany?: string;
    jobTitle?: string;
    userSelectedPlant?: string;
    customerServiceRepresentativeEmail?: string;
    soldTo?: string;
    shipTo?: string;
    customerNumber?: string;
}

export interface InviteYourColleagueModel {
    requestor: string;
    firstName: string;
    lastName: string;
    email: string;
    billTo: string;
    shipTo: string;
    jobTitle: string;
    portalInfo: any[];
    userHash?: string;
}

export interface AlternatePackagingAttributeValueModels {
    id: string;
    attributeTypeId: string;
    alternateAttributeValue: string;
    alternateAttributeValueDisplay: string;
    baseAttributeValueDisplay: string;
    sortOrder?: number;
}

export interface AlternatePackagingAttributesModel {
    id?: string;
    type?: string;
    alternatePackagingAttributeValueModels?: AlternatePackagingAttributeValueModels[];
}

export interface AlternatePackagingCollectionModel extends BaseModel {
    id: string;
    type?: string;
    typeDisplay?: string;
    categoryId?: string;
    superCategory?: string;
    subCategory?: string;
    alternatePackagingAttributes?: AlternatePackagingAttributesModel[] | null;
}

export interface AlternatePackagingModel {
    productErpNumber: string;
    superAndSubCategories: string;
    attributeTypes: AttributeTypeModel[];
}

export interface RecommnededProductRequestFileModel {
    data: string;
    fileName: string;
}

export interface AlternatePackagingRequestModel {
    billTo: string;
    shipTo: string;
    websiteUserName: string;
    alternativeType: string;
    alternativeShortDescription: string;
    currentPackagingItem: string;
    customerNumber: string;
    customerCompany: string;
    fullName: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    requestMessage: string;
    documents: RecommnededProductRequestFileModel[];
}

export interface ShipmentModel {
    id: string;
    deliveryDate: string | Date;
    deliveryDateDisplay: string;
    deliveryEtaString: string;
    deliveryMapUrl: string;
    deliveryTimeZone: string;
    greifOrderNumber: string;
    greifOrderLineNumber: {};
    greifOrderLineSequence: {};
    greifOrderNumberDisplay: string;
    purchaseOrderNumber: string;
    productNumber: string;
    customerProductNumber: string;
    productNumberDisplay: string;
    customerSequence: string;
    quantityOrdered: {};
    quantityShipped: {};
    quantityDisplay: string;
    deliveryTerms: string;
    deliveryStatus: string;
    deliveryStatusDisplay: string;
    shipmentNumber: string;
    shipmentNumberDisplay: string;
    canDownloadShipmentDocument: boolean;
    locationDescription: string;
}

export interface ShipmentCollectionModel {
    shipments: ShipmentModel[] | null;
    pagination: PaginationModel | null;
}

export interface ShipmentStatusModel {
    id: string;
    name: string;
    description: string;
}

export interface ShipmentStatusCollectionModel extends BaseModel {
    statuses: ShipmentStatusModel[] | null;
}

export interface NotificationsFollowedModel {
    followNewPrice?: boolean | null;
    followNewFeature?: boolean | null;
    followNewTec?: boolean | null;
    followUpcomingShipment?: boolean | null;
    followOrderShipped?: boolean | null;
    followOrderPickup?: boolean | null;
    followAccountActivationInvitation?: boolean | null;
    accountActivated?: boolean | null;
    followOrderChange?: boolean | null;
    language?: string;
}
export interface UserNotificationInviteCollegueModelShipTo {
    label: string;
    customerSequence: string;
}

export interface UserNotificationInviteCollegueModelSoldTo {
    label: string;
    customerNumber: string;
    shipTos: UserNotificationInviteCollegueModelShipTo[];
}

export interface UserNotificationInviteCollegueModel {
    soldTos?: UserNotificationInviteCollegueModelSoldTo[];
    responseCode?: string;
    errorMessage?: string;
}
export interface UserNotificationPreferencesModel {
    notificationsFollowed: NotificationsFollowedModel | null;
    customerSoldTo: UserNotificationInviteCollegueModel | null;
    responseCode: string;
    errorMessage: string | null;
}

export interface PersonasListModel {
    key: string;
    displayName: string;
}

export interface LocationFilterModel {
    location: string;
    locationDescription: string;
}

export interface ExtendedDocumentModel extends DocumentModel {
    plantNumber: string;
    plantDescription: string;
}

export interface ExternalDocumentModel extends ExtendedDocumentModel {
    isLoading?: boolean;
    hasLoaded?: boolean;
    isSuccess?: boolean;
}

export interface UNCertificateModel {
    PlantNumber: string;
    CertificateCode: string;
}

export interface DocumentExtensionModel {
    DocumentId: string;
    PlantNumber: string;
}

export interface MultiLocationCatalogResultModel {
    isMultiLocationCatalogProduct: boolean;
    availableAtOtherShipTos: MLCAvailableAtOtherShipTosModel;
}

export interface MLCAvailableAtOtherShipTosModel {
    [key: string]: {
        customerName: string;
        customerProductName: string;
    };
}

export interface LeadTimeEntryModel {
    ProductNumber: string;
    Plant: string;
    LeadTime: number;
    IsSpecialItem: boolean;
    MinimumOrderQuantity: number;
}

export interface LeadTimeModel {
    isSpecialItem?: boolean;
    plant?: string;
    leadTimeDays?: number;
    minimumOrderQuantity?: number;
}

export interface FullTruckLoadEntryModel {
    ProductNumber: string;
    Plant: string;
    FullTruckLoad: number;
}

export interface FullTruckLoadModel {
    plant?: string;
    ftlQuantity?: number | string;
}

export interface PlantModel {
    code: string;
    displayName: string;
}

export interface DocumentPlantModel extends PlantModel {
    isDefault?: boolean;
}

export interface TrailerPickupRequestModel {
    trailerId: string;
    shipToNumber: string;
    shipmentNumber: string;
    requestedOn: string;
    pickupOption: string;
    requestedPickupDate: string;
    additionalNotes: string;
}

export interface TrailerModelV2 {
    dwellTimeInDays: number;
    id: string;
    isDwellTimeOverComplimentaryLimit: boolean;
    orderNumbers: Array<string>;
    plantName: string;
    poNumber: string;
    shipmentNumber: string;
    pickupRequest: TrailerPickupRequestModel | null;
}

export interface TrailerTrackingV2ComplimentaryLimitAlertModel {
    code: string;
    description: string;
}

export enum TrailerTrackingV2DwellTimeOperatorApiValues {
    GreaterThan = "gt",
    LessThan = "lt",
    Equal = "eq",
}

export enum TrailerTrackingV2BillingTypeApiValues {
    DwellTime = "DwellTime",
    Quantity = "Quantity",
    Fixed = "Fixed",
}

export interface TrailerTrackingV2BillingTypeModel {
    complimentaryAmount?: number;
    contractPoNumber: string;
    cost: number;
    displayCost: string;
}

export interface TrailerTrackingV2BillingModel {
    byDwellTime?: TrailerTrackingV2BillingTypeModel[];
    byFixed?: TrailerTrackingV2BillingTypeModel[];
    byQuantity?: TrailerTrackingV2BillingTypeModel[];
}

export interface TrailerTrackingV2Model {
    billing?: TrailerTrackingV2BillingModel;
    complimentaryLimitAlerts?: TrailerTrackingV2ComplimentaryLimitAlertModel[];
    id: string;
    shipToCustomerSequence: string;
    shipToAddress: string;
    shipToName: string;
    trailers: TrailerModelV2[];
    trailersCount: number;
}

export interface TrailerTrackingV2CollectionModel extends BaseModel {
    trailerTrackings: TrailerTrackingV2Model[] | null;
    pagination: PaginationModel | null;
    plants: PlantModel[];
    filteredTrailerCount: number;
    totalTrailerCount: number;
}

export interface RequestTrailerPickupResponseModel extends BaseModel {
    dropTrailerPickupRequest: TrailerPickupRequestModel;
}
